/**
 * Platform tile (demo /connected-apps app icon): a rounded square with the platform's brand mark. Brand colors live
 * in ./platform-brand.ts; an unknown platform gets a neutral tile with its two-letter abbreviation.
 */
import React from 'react';
import { BRAND_MARK_COLOR, PLATFORM_BRANDS, brandBackground } from './platform-brand.js';

interface PlatGlyphProps {
  platform: string;
  /** Tile size in px (default 28). */
  size?: number;
  /** Corner radius in px (default 8). */
  radius?: number;
}

export const PlatGlyph: React.FC<PlatGlyphProps> = ({ platform, size = 28, radius = 8 }) => {
  const brand = PLATFORM_BRANDS[platform.toLowerCase()];
  const label = brand?.label ?? platform.slice(0, 2).toUpperCase();

  return (
    <span
      role="img"
      aria-label={platform}
      className={[
        'inline-grid place-items-center font-mono font-bold shrink-0',
        brand ? '' : 'bg-surface-alt text-muted',
        brand?.outlined ? 'border border-strong' : '',
      ]
        .filter(Boolean)
        .join(' ')}
      style={{
        width: size,
        height: size,
        borderRadius: radius,
        fontSize: size <= 28 ? 11 : 16,
        ...(brand ? { backgroundColor: brandBackground(brand), color: BRAND_MARK_COLOR } : {}),
      }}
    >
      {label}
    </span>
  );
};
